import { InjectionToken } from '@angular/core';

export const MODAL_PANEL_CLASSES = new InjectionToken<string[]>('MODAL_PANEL_CLASSES');
